export const storageHistory = {
	title: "Relatório de Movimentação",
	description:
		"Neste relatório, é possível analisar as movimentações de entrada e saída por estoque, produto e categoria durante o período desejado, levando em consideração as perdas associadas.",
	label: "Movimentação",
	filename: "relatorio-de-movimentacao",
	print: "Imprimir",
	export: "Download em Excel",
	cleanFilters: "Limpar filtros",
	emptyState: {
		title: "Selecione e aplique os filtros para começar",
		description:
			"Você precisa selecionar ao menos um estoque, uma categoria ou um produto e o período para começar",
	},
	storages: {
		label: "Estoques",
		placeholder: "Busque por estoque",
	},
	filterBy: {
		label: "Filtrar por",
		category: "Categoria",
		product: "Produto",
	},
	products: {
		label: "Produtos",
		placeholder: "Busque por produto",
	},
	categorys: {
		label: "Categorias",
		placeholder: "Busque por categoria",
	},
	period: "Período",
	filter: "Aplicar filtros",
	hideProducts: "Não mostrar itens com ficha técnica",
	dateFilterBy: {
		label: "Filtrar período por",
		options: {
			events: "Eventos entre o período",
			interval: "Todos entre o período",
		},
	},
	columns: {
		name: "Produto",
		ube: "Unidade",
		inicial: "Quantidade Inicial",
		input: "Entrada de produtos",
		transfer: "Transferência interna",
		sell: "Vendas",
		productionIn: "Entrada de produção",
		productionOut: "Saída de produção",
		lost: "Perdas",
		manual: "Ajuste Manual",
		cardExchange: "Devoluções",
		result: "Final",
		lossPercentage: "Porcentagem de perdas",
	},
	editModal: {
		title: "Editar alertas de estoque para {{productName}}",
		deleteWarning: "Tem certeza que deseja excluir o alerta de {{productName}}?",
		delete: "Excluir alerta",
		storageIn: "Estoque em",
		alert: "Alerta",
		critical: "Crítico",
		storage: "Estoque",
		below: "abaixo de",
		invalidText:
			"O valor de estoque em alerta não pode ser menor que o valor de estoque critico",
	},
	printable: {
		product: "Produto",
		initialQuantity: "Qnt. Inicial",
		productEntry: "Ent. de Prod.",
		internalTransfer: "Transf. Interna",
		sales: "Vendas",
		productionEntry: "Ent. de Produção",
		productionOutput: "Saída de Produção",
		losses: "Perdas",
		manualAdjustment: "Ajuste Manual",
		final: "Final",
		withoutProducts: "Sem produtos selecionados",
	},
	storageReport: "Relatório de estoque",
};
